export default __webpack_public_path__ + "90797cff9fcf5439a21889280011890d.wasm";